var __jsx = React.createElement;
import React, { useState } from "react";
import { faLink, faUser } from "@fortawesome/pro-regular-svg-icons";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import { getFormattedDate } from "../../utils";
import { truncate } from "lodash";
var SharePatients = function SharePatients(_ref) {
  var result = _ref.result,
    status = _ref.status,
    setCopyStarted = _ref.setCopyStarted,
    setResults = _ref.setResults,
    isCopyLoading = _ref.isCopyLoading;
  var getGenderString = function getGenderString(genderCode) {
    switch (genderCode) {
      case 0:
        return "M";
      case 1:
        return "F";
      case 2:
        return "O";
      default:
        return "";
    }
  };
  var _useState = useState(false),
    isCopied = _useState[0],
    setIsCopied = _useState[1];
  if (status === "complete" && !result) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 py-4 rounded-lg max-w-[75%] dark:bg-gray-800 bg-gray-500 text-white rounded-tl-none"
    }, /*#__PURE__*/React.createElement("p", {
      className: "whitespace-pre-wrap"
    }, "No patients found, please try again."));
  }
  if (status === "complete" && result) {
    var _result = result.current || result;
    var copyToClipboard = function copyToClipboard() {
      setIsCopied(true);
      setCopyStarted(true);
      setTimeout(function () {
        setIsCopied(false);
      }, 2000);
      setResults(_result);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "w-[80%] border dark:border-gray-800 border-gray-300 dark:border-gray-700 rounded-lg rounded-tl-none dark:text-gray-200 text-gray-700"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dark:bg-gray-900 bg-gray-200 shadow-md overflow-hidden border-0 rounded-lg rounded-tl-none"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-4 border-b dark:border-gray-800 border-gray-300 flex justify-between items-center dark:bg-gray-800 bg-gray-500"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-lg font-medium text-white"
    }, "Patient Information"))), /*#__PURE__*/React.createElement("div", {
      className: "p-4 border-b dark:border-gray-800 border-gray-300"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-start gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-8 w-8 rounded-md dark:bg-gray-800 bg-gray-400 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faUser,
      className: "h-5 w-5 text-[#FFA387]"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dark:text-white text-gray-700 break-words"
    }, _result !== null && _result !== void 0 && _result.name ? truncate(_result === null || _result === void 0 ? void 0 : _result.name, {
      length: 20
    }) : "Patient"), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, "| ", _result === null || _result === void 0 ? void 0 : _result.age, "Y ", getGenderString(_result === null || _result === void 0 ? void 0 : _result.gender))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-start text-md text-gray-500 mt-2"
    }, /*#__PURE__*/React.createElement("span", null, getFormattedDate((_result === null || _result === void 0 ? void 0 : _result.created_at) || ""))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      onClick: copyToClipboard,
      className: "py-3 px-5 text-md rounded-md flex items-center gap-2 transition-colors ".concat(isCopied ? " text-brand-peach" : isCopyLoading ? "dark:bg-gray-800 bg-gray-300 text-gray-300" : "dark:bg-gray-800 bg-gray-300 text-brand-peach dark:hover:bg-gray-700 hover:bg-gray-100")
    }, isCopied ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCheck,
      size: "lg"
    }), /*#__PURE__*/React.createElement("span", null, "Copied!")) : isCopyLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faSpinner,
      className: "animate-spin"
    }), /*#__PURE__*/React.createElement("span", null, "Sharing...")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faLink,
      size: "lg"
    }), /*#__PURE__*/React.createElement("span", null, "Copy link")))))))));
  }
  if (status === "executing") {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full dark:bg-gray-950 border dark:border-gray-800 border-gray-300 rounded-lg dark:text-gray-200 text-gray-700"
    }, /*#__PURE__*/React.createElement("div", {
      className: "max-w-2xl mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dark:bg-gray-900 bg-gray-200 shadow-md overflow-hidden border-0 rounded-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-4 border-b dark:border-gray-800 border-gray-300 flex justify-between items-center dark:bg-gray-800 bg-gray-500"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-40 dark:bg-gray-700 bg-gray-400 rounded-md animate-pulse"
    })), /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-32 dark:bg-gray-700 bg-gray-400 rounded-md animate-pulse"
    })), /*#__PURE__*/React.createElement("div", {
      className: "p-4 border-b dark:border-gray-800 border-gray-300"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-start gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-8 w-8 rounded-full dark:bg-gray-800 bg-gray-400 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-40 dark:bg-gray-800 bg-gray-400 rounded-md animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-20 dark:bg-gray-800 bg-gray-400 rounded-md animate-pulse mt-1"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "h-8 w-28 dark:bg-gray-800 bg-gray-400 rounded-md animate-pulse"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end mt-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-3 w-40 dark:bg-gray-800 bg-gray-400 rounded-md animate-pulse"
    }))))));
  }
};
export default SharePatients;